import styled from 'styled-components'

export const Icon = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  cursor: pointer;
  position: ${(props) => props.position};
  opacity: ${({ opacity }) => opacity};
  background: ${(props) => props.background || 'transparent'};
  background-color: ${(props) => props.backgroundColor};
  padding-left: ${(props) => props.paddingLeft};
  margin-bottom: ${(props) => props.marginBottom};

  margin-left: ${(props) => props.marginLeft};
  transform: ${(props) => props.transform};
`
export const TextArea = styled.textarea`
  width: 100%;
  height: ${(props) => props.height};

  background-color: 'rgba(255, 255, 255, 0.34)';

  padding: 12px 20px;
  /* box-sizing: border-box;
  border: 2px solid #ccc; */
  font-family: nudista-web, sans-serif;
  opacity: 0.7;
  /* text-align: ce; */

  border: transparent;
  border-radius: 4px;
  font-size: 11px;
  resize: none;
  box-shadow: 0px 6px 6px 2px rgba(0, 0, 0, 0.26);
`
export const SearchFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  text-overflow: ellipsis;

  position: ${(props) => props.position};
  padding: ${(props) => props.padding};
  top: ${(props) => props.top};
  white-space: ${(props) => props.whiteSpace};
  box-shadow: ${(props) => props.boxShadow};

  display: flex;
  flex-direction: row;
  flex-flow: ${(props) => props.flexFlow};
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: ${(props) => props.alignItems || 'center'};
  align-self: ${(props) => props.alignSelf};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  background-color: ${(props) =>
    props.backgroundColor || 'rgba(255, 255, 255, 0.34)'};
  border-left: ${(props) => props.border};

  border-radius: ${(props) => props.borderRadius};
  background-image: url(${(props) => props.src});
`
export const SInput = styled.input`
  background-image: url(${({ icon }) => icon});
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 14px 0.6rem;
  padding-left: ${(props) => props.paddingLeft || '40px'};
  opacity: ${(props) => props.placeholderOpaciy || '0.77'};
  border-radius: 4px;
  width: ${({ width }) => width};
  height: 31px;
  border: none;
  padding: ${(props) => props.padding};
  background-color: rgba(255, 255, 255, 0.34);
  ::placeholder {
    font-family: nudista-web, sans-serif;
    font-size: ${(props) => props.placeholderFont || '11px'};
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    /* width: 100px; */

    color: ${(props) => props.placeholderColor || '#250f43'};
  }
  font-family: nudista-web, sans-serif;
  font-size: 12px;
  font-weight: 500;

  font-stretch: normal;
  font-style: normal;
  line-height: 1px;
  letter-spacing: normal;
  text-align: left;
  color: #250f43;
`

export const P = styled.p`
  width: ${(props) => props.width || 'auto'};
  max-width: ${(props) => props.maxWidth};
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'row'};

  text-align: ${(props) => props.textAlign};

  align-self: ${(props) => props.alignSelf};
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};

  overflow-wrap: break-word;

  margin: ${(props) => props.margin};

  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: ${(props) => props.marginTop};

  opacity: ${(props) => props.opacity};

  line-height: ${(props) => props.lineHeight};

  height: ${(props) => props.height};
  color: ${(props) => props.color};
  text-align: ${(props) => props.textAlign};
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  font-family: nudista-web, sans-serif;

  font-style: normal;

  background-image: ${(props) => props.backgroundImage};
  background-color: ${(props) => props.backgroundColor};
`

export const ColumnFlexDiv = styled.div`
  display: ${(props) => props.display || 'flex'};
  flex-direction: column;
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  visibility: ${(props) => props.Visibility};

  overflow: hidden;

  position: ${(props) => props.position};
  padding: ${({ padding }) => padding};

  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};

  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  :hover {
  }
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  border: ${(props) => props.border};

  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
`

export const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  outline: ${(props) => props.outline};
  text-overflow: ellipsis;

  position: ${(props) => props.position};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  left: ${(props) => props.left};

  white-space: ${(props) => props.whiteSpace};
  cursor: ${(props) => props.Cursor};

  display: flex;
  flex-direction: row;
  flex-flow: ${(props) => props.flexFlow};
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: ${(props) => props.alignItems || 'center'};
  align-self: ${(props) => props.alignSelf};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
  margin-bottom: ${(props) => props.marginBottom};
  background-color: ${(props) => props.backgroundColor};
  box-shadow: ${(props) => props.boxShadow};

  border-radius: ${(props) => props.borderRadius};
  border: ${(props) => props.border};

  background-image: ${(props) => props.src};
`

export const UserProfilePictureHolder = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  border-radius: ${(props) => props.borderRadius || '50%'};
  position: ${(props) => props.position};
  margin-left: ${(props) => props.marginLeft};
  z-index: ${(props) => props.zIndex};
`
export const UserProfilePicture = styled.img`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`

export const SearchInput = styled.input`
  background-image: url(${({ icon }) => icon});
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 14px 0.6rem;
  padding-left: ${(props) => props.paddingLeft || '40px'};
  opacity: 0.77;
  border-radius: 4px;
  width: ${({ width }) => width};
  min-width: ${({ minWidth }) => minWidth};
  height: 31px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: none;
  background-color: rgba(255, 255, 255, 0.34);
  ::placeholder {
    font-family: nudista-web, sans-serif;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #250f43;
  }
  font-family: nudista-web, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #250f43;
`

export const DropDownInput = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px 0 10px;
  border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
`

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;
  width: 100%;
  height: 100%;
  padding: 18px 0 18px 0;
`

export const HomeNavWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 40px;
`

export const ViewSelectionButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding-bottom: ${({ active }) => (active ? '6px' : '8px')};
  cursor: pointer;
  opacity: ${({ active }) => (active ? '1' : '0.28')};
  border-bottom: ${({ active }) => (active ? 'solid 2px #fb8f02' : null)};
`

export const GradientBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 31px;
  min-height: 31px;
  width: 31px;
  height: 31px;
  border-radius: 5px;
  background-image: linear-gradient(to bottom, #f19d4c, #c16e97 52%, #8840e1);
`

export const AssignmentHolderBlurred = styled.div`
  width: 100%;
  height: 120px;
  z-index: -1;
  position: absolute;
  background-image: url(${({ bg }) => bg});
  filter: blur(8px);
  -webkit-filter: blur(8px);
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`
export const AssignmentDetailsHolderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px 10px 1px 10px;
  height: 20px;
  border-radius: 12px;
  opacity: 0.9;
  background-color: rgba(0, 0, 0, 0.64);
`

export const AssignmentHomeImageHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 66.5px;
  height: 60.5px;
  border-radius: 8px;
  overflow: hidden;
`

export const AssignmentHomeImage = styled.img`
  height: 62px;
`

export const ScrollableDiv = styled.div`
  display: grid;
  width: ${({ width }) => width};
  gap: ${({ gap }) => gap};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow-x: hidden;
  overflow-y: scroll;
`

export const CarouselHolderDiv = styled.div`
  height: 400px;
  width: 30vw;
  margin: auto;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 980px) {
    height: 260px;
    width: 100%;
    margin: auto;
  }
`

export const CarouselOuter = styled.div`
  width: 100%;
  display: block;
  height: max-content;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  @media (max-width: 980px) {
    margin-top: 0;
  }
`
